// extracted by mini-css-extract-plugin
export default {"container":"ExpenseTrackerApp_container__-+7qw"};